import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  ref: "modal-backdrop",
  class: "fixed z-10 inset-0 overflow-y-auto bg-black bg-opacity-50"
}
const _hoisted_2 = { class: "flex flex-col items-center justify-center min-h-screen text-center" }
const _hoisted_3 = {
  class: "relative bg-white rounded-lg text-left overflow-hidden shadow-xl w-11/12",
  role: "dialog",
  ref: "modal",
  "aria-modal": "true",
  "aria-labelledby": "modal-headline"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", { class: "absolute top-4 right-4" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-200 transform",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "transition ease-in duration-200 transform",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_Transition, {
              "enter-active-class": "transition ease-out duration-300 transform ",
              "enter-from-class": "opacity-0 translate-y-10 scale-95",
              "enter-to-class": "opacity-100 translate-y-0 scale-100",
              "leave-active-class": "ease-in duration-200",
              "leave-from-class": "opacity-100 translate-y-0 scale-100",
              "leave-to-class": "opacity-0 translate-y-10 translate-y-0 scale-95"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _renderSlot(_ctx.$slots, "default", {}, () => [
                    _createTextVNode("I'm empty inside")
                  ])
                ], 512), [
                  [_vShow, $setup.showModal]
                ])
              ]),
              _: 3
            })
          ])
        ], 512), [
          [_vShow, $setup.showModal]
        ])
      ]),
      _: 3
    })
  ]))
}